<template>
  <div class="wrap">
    <img src="../../../assets/img/order_not.png" alt="">
    <p>亲，暂无相关订单哦</p>
  </div>
</template>

<script>
export default {
  name: 'not-goods'
}
</script>

<style scoped lang="scss">
.wrap{
  margin: auto;
  margin-top: 50px;
  width: 305px;
  height: 240px;
  border-radius:10px;
  text-align: center;
  position: relative;
  img{
    display: inline-block;
    width: 161px;
    margin-top: 8px;
  }
  p{
    font-size: 12px;
    color: #555555FF;
    margin: 20px 0;
  }
}
</style>
